import { render, staticRenderFns } from "./TrafficStructure.vue?vue&type=template&id=bd9f4a00&scoped=true&"
import script from "./TrafficStructure.vue?vue&type=script&lang=js&"
export * from "./TrafficStructure.vue?vue&type=script&lang=js&"
import style0 from "./TrafficStructure.vue?vue&type=style&index=0&id=bd9f4a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9f4a00",
  null
  
)

export default component.exports